import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/axios'

import { sync } from 'vuex-router-sync'

sync(store, router)

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters["user/getLogedinStatus"]
  if (!store.getters['user/getLogedinStatus'] && to.path !== '/login') {
    store.dispatch('user/logout')
    next('login')
  } else if(store.getters['user/getLogedinStatus'] && to.path === '/login'){
    next("overview")
  } else{
    next()
  }

})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
